/* eslint-disable import/prefer-default-export */

/**
 * convenience wrapper around Array.prototype.find() to return first bundle that
 * matches provided layout.
 *
 * @export
 * @param {Object[]} [bundles=[]] array of bundle objects
 * @param {String} [bundles[].layout] layout property of bundle
 * @param {String} [layout=''] bundle layout to find
 * @returns {Object} first bundle that matches provided layout
 */
export function getBundle(bundles, layout = '') {
  if (!bundles) {
    return undefined;
  }
  return bundles.find(bundle => bundle.layout === layout);
}
